__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = function(name, initScope) {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = function(msg) { return typeof console !== "undefined" && console.warn && console.warn(msg); };
	var uniqueName = "app";
	var register = function(name, version, factory, eager) {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = function(id) {
		var handleError = function(err) { warn("Initialization of sharing external failed: " + err); };
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = function(module) { return module && module.init && module.init(__webpack_require__.S[name], initScope); }
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@axa-fr/react-oidc", "6.16.9", function() { return function() { return __webpack_require__(71550); }; }, 1);
			register("cf-app-shell", "0.53.1-CFE-475.11", function() { return __webpack_require__.e(787).then(function() { return function() { return __webpack_require__(4787); }; }); });
			register("mintel-taskbar", "6.13.1", function() { return Promise.all([__webpack_require__.e(795), __webpack_require__.e(781), __webpack_require__.e(474), __webpack_require__.e(563)]).then(function() { return function() { return __webpack_require__(25781); }; }); });
			register("react-dom", "17.0.2", function() { return function() { return __webpack_require__(26796); }; }, 1);
			register("react", "17.0.2", function() { return function() { return __webpack_require__(43745); }; }, 1);
			register("wouter", "2.10.0", function() { return function() { return __webpack_require__(69632); }; }, 1);
			initExternal(3602);
			initExternal(82408);
			initExternal(86240);
			initExternal(25513);
			initExternal(70453);
			initExternal(86518);
			initExternal(83775);
			initExternal(4407);
			initExternal(17205);
			initExternal(93129);
			initExternal(83971);
			initExternal(24585);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(function() { return initPromises[name] = 1; });
};